import { useState } from "react";

/**
 * "NOVIDADE" ao lado de um recurso que a pessoa não sabe que existe.
 *
 * Existe UM só, usado em todos os lugares, porque selo repetido com dois
 * tamanhos diferentes é pior que selo nenhum: vira ruído em vez de pista.
 *
 * Fundo SÓLIDO, nunca `acao-clara`: a linha ativa da barra lateral já usa
 * `acao-clara` de fundo, e um selo claro sumiria exatamente na tela em que a
 * pessoa está.
 *
 * COMO APOSENTAR: quando o recurso deixar de ser novidade, apague as
 * chamadas — não este arquivo. Selo que fica para sempre deixa de ser lido,
 * e aí o próximo recurso novo nasce invisível.
 */
/**
 * Lembra quais novidades a pessoa já usou.
 *
 * `localStorage` e não servidor: é preferência de ESTE navegador e não vale
 * a pena uma coluna no banco — o pior caso é o selo reaparecer em outra
 * máquina, que é exatamente o comportamento desejável ali.
 *
 * Toda leitura e escrita em try/catch: em janela anônima ou com dados de
 * site bloqueados o acesso LANÇA, e um selo não pode derrubar a barra
 * lateral inteira.
 */
const CHAVE = "cdw:novidades-vistas";

function jaViu(id: string): boolean {
  try {
    return (localStorage.getItem(CHAVE) ?? "").split(",").includes(id);
  } catch {
    return false;
  }
}

/** Marca a novidade como usada. Chamar no CLIQUE, não na exibição. */
export function novidadeUsada(id: string): void {
  try {
    const vistas = (localStorage.getItem(CHAVE) ?? "").split(",").filter(Boolean);
    if (!vistas.includes(id)) {
      localStorage.setItem(CHAVE, [...vistas, id].join(","));
    }
  } catch {
    // Sem armazenamento o selo continua aparecendo. É o pior caso, e é
    // melhor que a tela quebrar.
  }
}

/**
 * O selo só aparece até a pessoa USAR o recurso.
 *
 * Antes ele era permanente, e selo que fica para sempre deixa de ser lido —
 * aí o próximo recurso novo nasce invisível, que é o contrário do que ele
 * existe para fazer. "Usar" é clicar, não ver: quem só passou os olhos não
 * descobriu nada.
 */
export function SeloNovidade({
  id,
  className = "",
}: {
  id: string;
  className?: string;
}) {
  const [visto] = useState(() => jaViu(id));
  if (visto) return null;
  return (
    <span
      className={`inline-block shrink-0 rounded-full bg-acao px-1.5 py-px align-middle text-[9px] font-bold uppercase tracking-wider text-white ${className}`}
    >
      Novidade
    </span>
  );
}
